import { useDeleteEntityApi } from '@/common/api/deleteEntityApi';
import { usePackageTypeStore } from 'shared/packages/stores/packageTypeStore';

export function useDeletePackageType() {
  const store = usePackageTypeStore();

  return useDeleteEntityApi({
    url: 'packageType',
    translate: (t) => t.packageTypes.actions.delete,
    async processOk(request) {
      store.remove(request.id);
      return Promise.resolve({ ok: true });
    },
  });
}
